import axios from 'axios';
export const parseQuote = (quote) => { // exported for testing purposes
    if (!quote || typeof quote !== 'string') {
        return []; // Return an empty array for invalid input
    }
    const cleanedQuote = quote.split("`").join("'");
    // Split the quote into words, filtering out empty strings from multiple spaces
    const wordsArray = cleanedQuote.split(' ').filter(word => word.length > 0);
    // Add a space to each word except the last one
    const result = wordsArray.map((word, index) => 
        index < wordsArray.length - 1 ? word + ' ' : word
    );
    return result;
};
export function calculateTypingTime(wordCount, wpm=30, errorRate=0.10){ // exported for testing purposes
    if (wordCount <= 0 || wpm <= 0){
        return 0;
    }
    const netWPM = wpm * (1-errorRate);
    const timeMinutes = wordCount / netWPM;
    const timeSeconds = timeMinutes * 60;
    const roundedMinutes = Math.ceil(timeSeconds / 60);
    return roundedMinutes * 60;
}
// TODO: set try catch in this async function
const createGame = async() => {
    let response = await fetchText();
    // Keep text as string - always derive words client-side via parseQuote
    let text = response.data.text;
    let parsedData = parseQuote(text);
    let totalCharacters = response.data.text.length;
    const estimatedTime = Math.ceil(calculateTypingTime(parsedData.length))    
    return {
        // Always return text as string - components will parse it client-side
        text: text,
        totalCharacters: totalCharacters,
        estimatedTime: estimatedTime
    }    
}
const fetchText = async() => {    
    try {
        return await axios.get('https://uselessfacts.jsph.pl/random.json?language=en');
    }catch(err){
        console.log(err);
    }
}
export const createPlayerObj = (id) => {
    return{
        id : id,
        currentLetters : 1,
        currentWord : 0,
        wpm: 0,
        timeElapsed : 0,
        hash : {},
        races : [],
        gameEnd: false,
        position: -1
    }
}
export const createPracticeGame = async() => {
    let gameObject = await createGame();
    return gameObject;
}

export const loadGameAssets = async(solo_id,gameType) => {
    let playerObj = createPlayerObj(solo_id);    
    let gameData;    
    try {
        // TODO: set up if statements for multiplayer and private games                
            gameData = await createPracticeGame();                        
    }catch(err){
        throw Error(err);
    }
    return {
        playerObj: playerObj,
        gameData: gameData
    }
}
